import { useOutletContext } from 'react-router-dom';

export interface ILayoutContext {
	setIsTableOfContents: (isSetTableOfContents: boolean) => void;
}

export const useLayoutContext = () => {
	return useOutletContext<ILayoutContext>();
};
